import { Checkbox, FormControlLabel, Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import { convertToFormattedString } from 'utils/helper';

RHFCheckboxGroup.propTypes = {
  name: PropTypes.string,
  title: PropTypes.string,
  options: PropTypes.array,
};
export default function RHFCheckboxGroup({ name, title, options }) {
  const { watch, setValue } = useFormContext();
  const selectedValues = watch(name) || [];

  const handleToggle = (option) => {
    const newValues = selectedValues.includes(option)
      ? selectedValues.filter((v) => v !== option)
      : [...selectedValues, option];
    setValue(name, newValues);
  };

  return (
    <Stack gap={1}>
      <Typography variant="body2" color="grey">
        {title}
      </Typography>
      <Stack direction="row" gap={2} flexWrap="wrap">
        {options?.map((option) => (
          <FormControlLabel
            key={option}
            label={convertToFormattedString(option)}
            control={
              <Checkbox
                checked={selectedValues.includes(option)}
                onChange={() => handleToggle(option)}
                sx={{
                  '&.Mui-disabled': {
                    color: (theme) => theme.palette.primary.main, // change to any color you prefer
                    opacity: '0.9',
                  },
                }}
              />
            }
          />
        ))}
      </Stack>
    </Stack>
  );
}
